import { AlertsCourtView } from "./alerts-court";
import { AlertsCourtModel } from "../models/alerts-court";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "table",
    className: "alerts-court-list",
    childView: AlertsCourtView
})

export class AlertsCourtListView extends Marionette.CollectionView<AlertsCourtModel, AlertsCourtView> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-court-list.ts